<template>
    <v-dialog 
      persistent 
      width="fit-content" 
      v-model="dialog"
    >
      <v-card 
        width="fit-content" 
        height="fit-content">
        <v-card-text v-if="importingError" class="px-3">
            <v-card-title class="text-body-1 error--text py-0 pt-3 justify-end">
                <!-- <span>{{ importingError.message }}</span> -->
                <v-btn @click="$emit('close')" v-if="importingError" icon class="">
                    <v-icon color="error">mdi-close-circle</v-icon>
                </v-btn> 
          </v-card-title>
          <v-card-text class="px-0 pb-0">
            <v-list-item class="px-0" two-line>
              <v-list-item-icon class="mx-auto px-3 my-auto">
                <v-icon color="error">mdi-alert-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ importingError.message }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card-text>
        <v-card-text v-else class="text-center">
            <v-card-title class="text-body-1">
              {{ $t('common.importInProgress') }}
            </v-card-title>
            <v-progress-circular width="5" size="40" indeterminate color="success">
            </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        importProcessLoading: {
            type: Boolean,
            required: true
        },
        importingError: {
            type: Object
        }
    },

    data() {
        return {
            
        }
    },

    computed: {
      dialog(){
        return !!this.importingError
      }
    },

    methods: {
        
    },
};
</script>

<style scoped>

</style>